import MarkerClusterer from '@googlemaps/markerclustererplus';
import getInfoWindowClass from '../map/getInfoWindowClass';
import loadGMapAPI from '../map/loadGMapApi';
import styles from '../map/styles';
import { createGMapPlaceholder } from '../cookies-manager/placeholders';

/* global google */

const $locator = document.querySelector('.js-locator');
const $map = document.querySelector('.js-locator-map');
const $items = document.querySelectorAll('.js-locator-item');

async function initMap() {
  return loadGMapAPI().then(() => {
    // Create map
    const map = new google.maps.Map($map, {
      center: {
        lat: 46.227636,
        lng: 2.213749,
      },
      zoom: 6,
      maxZoom: 17,
      disableDefaultUI: true,
      zoomControl: true,
      clickableIcons: false,
      styles,
    });
    let iw;
    const markers = [];
    let cluster;

    if ($items.length) {
      const getMarkerIcon = (type) => ({
        path: 'M13.001.667C5.906.667.168 6.405.168 13.5c0 9.625 12.833 23.833 12.833 23.833S25.835 23.125 25.835 13.5C25.835 6.405 20.096.667 13 .667Zm0 17.416A4.585 4.585 0 0 1 8.418 13.5a4.585 4.585 0 0 1 4.583-4.583 4.585 4.585 0 0 1 4.584 4.583A4.585 4.585 0 0 1 13 18.083Z',
        fillColor: type === 'reseller' ? '#00828e' : '#000',
        fillOpacity: 1,
        strokeColor: type === 'reseller' ? '#00828e' : '#000',
        anchor: new google.maps.Point(13, 38),
      });

      const closeMarker = (marker) => {
        iw.hide();
        iw.marker = null;
      };

      const openMarker = (marker) => {
        iw.marker = marker;

        iw.update(marker.position || marker.center, marker.iwContent);
        iw.show();
      };

      const toggleMarker = (marker) => {
        if (iw.marker && iw.marker === marker) {
          closeMarker(marker);
        } else {
          openMarker(marker);
        }
      };

      const fitMap = (allCoords = []) => {
        if (allCoords.length) {
          const bounds = new google.maps.LatLngBounds();

          allCoords.forEach((coords) => {
            bounds.extend(coords);
          });

          map.fitBounds(bounds);
        } else {
          cluster.fitMapToMarkers();
        }
      };

      // Create InfoWindow instance
      const InfoWindow = getInfoWindowClass();
      iw = new InfoWindow(map, {
        class: 'c-drivetostore__locator-iw',
      });

      $items.forEach(($item) => {
        const marker = new google.maps.Marker({
          position: {
            lat: parseFloat($item.getAttribute('data-lat')),
            lng: parseFloat($item.getAttribute('data-lng')),
          },
          map,
          icon: getMarkerIcon($item.getAttribute('data-type')),
          iwContent: $item.innerHTML,
        });

        marker.addListener('click', () => {
          toggleMarker(marker);
        });

        markers.push(marker);
      });

      // Instanciate clusters
      cluster = new MarkerClusterer(map, markers, {
        ignoreHidden: true,
        styles: [{
          width: 60,
          height: 60,
        }],
      });

      // Close infoWindow when clicking outside of a marker
      google.maps.event.addListener(map, 'click', () => {
        if (iw.marker) {
          closeMarker(iw.marker);
        }
      });

      // Prevent InfoWindow to capture map's click, see : https://github.com/googlemaps/js-samples/issues/4
      google.maps.OverlayView.preventMapHitsFrom(iw.iw);

      fitMap();

      // When clicking on card, pan to marker
      const handleItemClick = (e) => {
        const $element = e.target.closest('.js-locator-item');
        const $interactiveElement = e.target.closest('a, button');
        if (!$element || $interactiveElement) return;

        const index = [...$items].indexOf($element);

        if (index !== -1) {
          map.setZoom(16);
          map.panTo(markers[index].position);
          openMarker(markers[index]);
        }
      };

      document.addEventListener('click', handleItemClick);
    }
  });
}

if ($locator) {
  // Cookie management
  let mapIsMounted = false;
  const $placeholder = createGMapPlaceholder();

  $map.append($placeholder);

  document.addEventListener('cookies:updateChoice', async (e) => {
    if (e.detail.gmaps) {
      if (!mapIsMounted) {
        await initMap();
      }
      $placeholder.remove();
      mapIsMounted = true;
    } else if (mapIsMounted) {
      $map.append($placeholder);
    }
  });

  // Locator switch
  const $swicth = document.querySelector('.js-locator-switch');

  if ($swicth) {
    let $currentActive;

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if ($currentActive) {
            $currentActive.classList.remove('is-active');
          }

          $currentActive = document.querySelector(`.js-locator-switch-anchor[href="#${entry.target.id}"]`);
          $currentActive.classList.add('is-active');
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '-33% 0px -33% 0px' });

    $swicth.querySelectorAll('.js-locator-switch-anchor').forEach(($anchor) => {
      const $target = document.querySelector($anchor.getAttribute('href'));
      observer.observe($target);
    });
  }
}
